module.exports = __webpack_public_path__ + "r-v3/img/device-mic-mini_on.db1cf59c.svg";